export const SOLICITUD = 1;
export const CERTIFICADO_LIQUIDACION  = 2;
export const OFERTA = 3;
export const ACEPTACION_OFERTA = 4;
export const ACTUALIZACION_DE_DEUDA = 5;
export const CLIENTE_SIN_OFERTAS = 6;
export const OFERTAS_PUBLICADAS = 7;
export const OFERTA_ACEPTADA_PARCIAL = 8;
export const ARREPENTIMIENTO_OFERTA = 9;
export const OFERTA_RECTIFICADA = 10;
export const RETRACTO_DE_OFERTA_POR_BANCO = 11;
export const BLOQUEO_DEUDA_ROTATIVA = 12;
export const PRORROGA_MANDATO = 13;
export const ENVIADA_A_REDBANC = 14;
export const SOLICITUD_CANCELADA = 15;